import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { User } from 'app/core/model/user';
import { UserDialogComponent } from '../user-dialog/user-dialog.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    standalone: false,
    selector: 'app-user-overview',
    templateUrl: './user-overview.component.html',
    styleUrl: './user-overview.component.scss',
})
export class UserOverviewComponent {
    uow = inject(BrewersUnitOfWork);
    router = inject(Router);
    auth = inject(AuthService);
    modalService = inject(BsModalService);
    appInfo = inject(AppInformationService);

    users: User[];

    async ngOnInit() {
        this.appInfo.pleaseWaitShow();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async getData() {
        const users = await this.uow.getUsers('userRoles.role');
        const currentUser = users.find((user) => user.id === this.auth.currentUser.id);
        if (!currentUser.email.includes('pectechnologies.com')) this.users = users.filter((user) => !user.email.includes('pectechnologies.com'));
        else this.users = users;
    }

    async open(user?: User) {
        const modalRef = this.modalService.show(UserDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                user: user,
            },
        });
        modalRef.content?.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                await this.getData();
                this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
        });
    }

    async rowDoubleClick(e) {
        if (!e.data) return;
        this.open(e.data);
    }
}
